module.exports = __webpack_public_path__ + "static/media/r3s1.a0becbcd.jpg";